import { createContext, useContext, Dispatch } from 'react';
import { UserCreationFormAction, UserCreationFormState } from './types';
import { INITIAL_USER_FORM } from './CreateUserFormReducer';

type UserCreationDispatchContextT = {
    dispatchUserCreationForm: Dispatch<UserCreationFormAction>;
    hasDispatchBeenCalled: React.MutableRefObject<boolean>;
};

export const UserCreationFormContext =
    createContext<UserCreationFormState>(INITIAL_USER_FORM);
export const UserCreationFormDispatchContext =
    createContext<UserCreationDispatchContextT>({
        dispatchUserCreationForm: () => {},
        hasDispatchBeenCalled: { current: false },
    });

export const useUserCreationFormDispatchContext = () =>
    useContext(UserCreationFormDispatchContext);
export const useUserCreationFormContext = () =>
    useContext(UserCreationFormContext);
